
const privacyBody = `**1. Data controller / Verantwortlicher**

[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa]
E-Mail: bringylatam@gmail.com

**2. Data we collect**

When you use the contact form on this site, we collect the following data: name, email address, route of interest, and the message you send us. This data is necessary so we can respond to you.

The website may store strictly necessary technical cookies for basic operation. We do not use third-party tracking or advertising cookies.

**3. Purpose of processing**

The form data is used solely to respond to your inquiry and manage your initial registration on the platform. It is not shared with third parties without your consent, except where required by law.

**4. Legal basis**

Processing is based on your consent (Art. 6(1)(a) GDPR) when you submit the form, and on the legitimate interest of managing the pre-contractual relationship (Art. 6(1)(b) GDPR).

**5. Data retention**

Contact form data is retained for as long as necessary to handle your request and, at most, 12 months from the last contact, unless a subsequent contractual relationship requires a longer period.

**6. Your rights**

You have the right to: access your personal data, request rectification or erasure, object to processing, request data portability, and lodge a complaint with the competent data protection authority.

To exercise your rights, write to us at: bringylatam@gmail.com

**7. Hosting**

This site is hosted on Cloudflare. Cloudflare may process technical access data (IP address, browser, date and time) as part of its network and security service. For more information: https://www.cloudflare.com/privacypolicy/

**8. Changes to this policy**

We may update this policy at any time. The current version will always be available on this page with the date of last update.`

const impressumBody = `Information pursuant to § 5 TMG / Información según § 5 TMG

**Verantwortlich / Responsible:**
[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa — calle, número, código postal, ciudad, país]

**Kontakt / Contact:**
E-Mail: bringylatam@gmail.com
Telefon / Phone: [COMPLETAR: +49 ... o número correspondiente]

**Plattformbetreiber / Platform operator:**
Bringy
[COMPLETAR: misma dirección legal]

**Umsatzsteuer-ID / VAT ID (if applicable):**
[COMPLETAR: DE... o número fiscal del país de registro]

**Haftungshinweis / Liability notice:**
Bringy acts as an intermediary platform between buyers and travelers. We are not a party to transactions between users and do not assume responsibility for the products exchanged, except as expressly provided in our Terms of Use.

The information provided on this website has been compiled with care; however, we do not guarantee its accuracy, completeness, or timeliness.

**Streitschlichtung / Dispute resolution:**
The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr
We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.`

export const en = {
  brand: {
    name: 'Bringy',
    tagline: 'Real people. Real products. Verified routes.',
  },
  nav: {
    howItWorks: 'How it works',
    whyUs: 'Why Bringy',
    offerings: 'Services',
    faq: 'FAQ',
    contact: 'Contact',
    cta: 'Get started',
  },
  hero: {
    eyebrow: 'Europe ↔ South America',
    titleAccent: 'Bring',
    titleRest: 'What Matters.',
    subtitle:
      'We connect people traveling between Europe and South America with those who need products from the other side. No courier, no agency — just real people with verified identity.',
    ctaBuscar: 'Find a product',
    ctaOfrecer: 'Offer as a traveler',
    trustBadges: [
      { label: 'Verified identity' },
      { label: 'Escrow payment' },
      { label: 'Public traveler score' },
      { label: 'Documented delivery' },
    ],
    boardingPass: {
      passengerLabel: 'PASSENGER',
      brand: 'BRINGY',
      sub: 'CARRY · VERIFIED · INSURED',
      fromCode: 'BER',
      fromCity: 'BERLIN',
      toCode: 'EZE',
      toCity: 'BUENOS AIRES',
      flight: 'FLIGHT BR · 2026',
      gate: 'GATE A7',
    },
    coordsBerlin: '52.52°N · 13.40°E',
    coordsBuenosAires: '34.60°S · 58.38°W',
  },
  launchTrust: {
    id: 'lanzamiento',
    launchNote:
      'Bringy is in launch phase. Each new traveler is personally verified by our team.',
    processTitle: 'Before a traveler carries a single item',
    processIntro:
      'We show the rigor of the process — not fabricated testimonials. That is how we build trust from day one.',
    stepVerified: 'Verified',
    stepPending: 'Pending',
    processSteps: [
      {
        number: '01',
        title: 'Identity verification',
        description: 'Official documents validated before operating on the platform.',
        icon: 'shield',
        verified: 'yes',
      },
      {
        number: '02',
        title: 'Onboarding via video call',
        description: 'An initial conversation with our team to explain rules and expectations.',
        icon: 'video',
        verified: 'yes',
      },
      {
        number: '03',
        title: 'Escrow agreement',
        description: 'Acceptance of protected-payment terms before the first transaction.',
        icon: 'lock',
        verified: 'yes',
      },
    ],
    foundingMembers: '{count} travelers have already registered their first route',
  },
  whyUs: {
    id: 'por-que',
    sectionLabel: '02 · Why Bringy',
    headline: 'Four guarantees.',
    headlineAccent: 'No exceptions.',
    title: 'Why Bringy works',
    subtitle:
      'Informal solutions already exist — WhatsApp groups, friends of friends. Bringy does the same, with the infrastructure it was missing.',
    cardAirline: 'BR · 2026',
    cardConfirmed: 'CONFIRMED',
    cardPending: 'PENDING',
    cardApproved: '· APPROVED ·',
    cardsMeta: [
      { value: 'IDENTITY', field: 'KYC · PASSPORT' },
      { value: 'INSURANCE', field: 'UP TO €4,000' },
      { value: 'COMPLIANCE', field: 'EU · AR · DECLARED' },
      { value: 'DELIVERY', field: 'PHOTO · TRACKED' },
    ],
    items: [
      {
        title: 'Verified trust',
        description:
          'Every traveler completes identity verification before operating on the platform. You know who you are dealing with.',
        icon: 'shield',
        verified: 'yes',
        badgeValue: 'IDENTITY',
        badgeField: 'KYC · PASSPORT',
      },
      {
        title: 'Your money, protected',
        description:
          'Funds stay in escrow until you confirm receipt of the product. No risk of paying for something that never arrives.',
        icon: 'lock',
        verified: 'yes',
        badgeValue: 'INSURANCE',
        badgeField: 'UP TO €4,000',
      },
      {
        title: 'Real reputation',
        description:
          'Each traveler builds a history of deliveries and ratings. You can see their score before coordinating.',
        icon: 'star',
        verified: 'yes',
        badgeValue: 'COMPLIANCE',
        badgeField: 'EU · AR · DECLARED',
      },
      {
        title: 'Documented delivery',
        description:
          'For extra security, we offer live verification with a Bringy representative via video call.',
        icon: 'video',
        verified: 'yes',
        badgeValue: 'DELIVERY',
        badgeField: 'PHOTO · TRACKED',
      },
    ],
  },
  services: {
    id: 'como-funciona',
    sectionLabel: '03 · How It Works',
    headline: 'A runway, not',
    headlineAccent: 'a checkout.',
    tagline: 'Four steps. One Atlantic crossing.',
    title: 'How it works',
    subtitle: '',
    footerLabels: { status: 'STATUS', eta: 'ETA', lane: 'LANE' },
    stepMeta: [
      { status: 'STANDBY', eta: '~ 18H', lane: 'A7' },
      { status: 'STANDBY', eta: '~ 36H', lane: 'B8' },
      { status: 'STANDBY', eta: '~ 54H', lane: 'C9' },
      { status: 'STANDBY', eta: '~ 72H', lane: 'D10' },
    ],
    steps: [
      {
        number: 1,
        title: 'Post your request',
        description:
          'Describe the product you need, the destination, and what you offer for the carry service.',
      },
      {
        number: 2,
        title: 'A traveler accepts',
        description:
          'Verified travelers with active routes see your request and offer to carry it on their next trip.',
      },
      {
        number: 3,
        title: 'You coordinate the details',
        description:
          'You agree on payment method, handover point, and timing directly with the traveler through the platform chat.',
      },
      {
        number: 4,
        title: 'Receive and confirm',
        description:
          'Once you have the product, you confirm delivery and payment is released to the traveler.',
      },
    ],
  },
  manifest: {
    sectionLabel: "04 · Today's Manifest",
    headline: 'The board,',
    headlineAccent: 'live.',
    tagline: 'All carries declared.',
    liveLabel: 'Live · {count} carries today',
    columns: ['Time', 'From → To', 'Carry', 'Status', 'Gate'],
    rows: [
      { time: '02:14', from: 'BER', to: 'EZE', carry: 'MEDICATION', status: 'INSURED', gate: 'A07', statusKey: 'insured' },
      { time: '06:40', from: 'MAD', to: 'EZE', carry: 'ELECTRONICS', status: 'VERIFIED', gate: 'B12', statusKey: 'verified' },
      { time: '09:25', from: 'FCO', to: 'EZE', carry: 'FOOTWEAR', status: 'BOARDING', gate: 'C04', statusKey: 'boarding' },
      { time: '11:55', from: 'CDG', to: 'EZE', carry: 'DOCUMENTS', status: 'INSURED', gate: 'D21', statusKey: 'insured' },
      { time: '14:30', from: 'LIS', to: 'EZE', carry: 'BOOKS', status: 'MATCHED', gate: 'A03', statusKey: 'matched' },
    ],
    footerLeft: 'EU → AR · Manifest 2026',
    footerRight: 'Pre-launch · All routes verified',
  },
  activeRoutes: {
    sectionLabel: '05 · Active Routes',
    headline: 'Europe departs.',
    headlineAccent: 'Buenos Aires waits.',
    tagline: 'Five corridors. One direction. We only carry what someone is already flying with.',
    routePrefix: 'ROUTE',
    originLabel: 'Origin',
    destLabel: 'Destination',
    flightLabel: 'Flight',
    openLabel: 'Open',
    routes: [
      { fromCity: 'Berlin',  fromCode: 'BER', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Madrid',  fromCode: 'MAD', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h' },
      { fromCity: 'Roma',    fromCode: 'FCO', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Paris',   fromCode: 'CDG', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h 30m' },
      { fromCity: 'Lisboa',  fromCode: 'LIS', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 12h 20m' },
    ],
  },
  offerings: {
    id: 'servicios',
    sectionLabel: '06 · Services',
    title: 'Services',
    buyer: {
      label: 'For buyers',
      title: 'Find what does not reach your country',
      body: 'Post what you need and connect with a verified traveler who is already making the trip. Access products at source prices, without middlemen.',
      cta: 'Post a request',
      products: [
        { name: 'iPhone 17 Pro · 256GB', price: '€ 980', route: 'Madrid → Buenos Aires', image: 'products/iPhone_17_Pro_Cosmic_Orange_PDP_Image_Position_1__DEDE-l.webp', imageAlt: 'iPhone 17 Pro' },
        { name: 'Nike Air Max 90', price: '€ 140', route: 'Berlin → Buenos Aires', image: 'products/nike.webp', imageAlt: 'Nike Air Max 90' },
        { name: 'PlayStation 5 Slim', price: '€ 480', route: 'Rome → Buenos Aires', image: 'products/sony-playstation-5-digital-edition-825-gb-wlan-schwarz-weiss.webp', imageAlt: 'PlayStation 5 Slim' },
        { name: 'Chanel Nº5 · 100ml', price: '€ 120', route: 'Paris → Buenos Aires', image: 'products/chanel-no-5-edp-vapo-200ml.png', imageAlt: 'Chanel Nº5' },
      ],
    },
    traveler: {
      label: 'For travelers',
      title: 'Monetize the free space in your luggage',
      body: 'Traveling between Europe and South America? Post your route and what you can carry. Offset part of your trip and build a reputation as a trusted traveler.',
      cta: 'Register as a traveler',
      routes: [
        { route: 'Berlin → Buenos Aires', activeTravelers: 'HQ · 3 active travelers' },
        { route: 'Madrid → Buenos Aires', activeTravelers: '12 active travelers' },
        { route: 'Rome → Buenos Aires', activeTravelers: '5 active travelers' },
        { route: 'Paris → Buenos Aires', activeTravelers: '4 active travelers' },
        { route: 'Lisbon → Buenos Aires', activeTravelers: '7 active travelers' },
      ],
    },
  },
  faq: {
    id: 'faq',
    title: 'Frequently asked questions',
    subtitle: '',
    items: [
      {
        question: 'How do I register on Bringy?',
        answer:
          'Complete the form with your name, email, and whether you want to buy or travel. We will contact you within 24 hours to guide you through the first steps.',
      },
      {
        question: 'Who can become a traveler?',
        answer:
          'Anyone over 18 who travels regularly between Europe and South America. Identity verification is required before posting active routes.',
      },
      {
        question: 'How do I know the traveler is trustworthy?',
        answer:
          'Each traveler has a profile with verification level, delivery history, and ratings from other users. More history means more confidence.',
      },
      {
        question: 'What happens to my money if the product never arrives?',
        answer:
          'Funds remain in escrow until you confirm receipt. If there is a problem, the Bringy team steps in and mediates between both parties.',
      },
      {
        question: 'What products can I request?',
        answer:
          'Any legal product that can be carried in cabin or checked baggage according to the customs regulations of the destination country. Electronics, apparel, cosmetics, non-perishable food, documents, among others.',
      },
      {
        question: 'How much does Bringy charge?',
        answer:
          'An 8–10% commission on each successful transaction. Frequent travelers can subscribe to Pro for €9/month, which removes the commission and offers additional visibility.',
      },
      {
        question: 'Can I request delivery with live verification?',
        answer:
          'Yes. For higher-value transactions or when both parties prefer it, a Bringy representative joins by video call, verifies identities, and documents the exchange.',
      },
      {
        question: 'Which routes are available?',
        answer:
          'We operate routes from Berlin (HQ), Madrid, Rome, Paris, and Lisbon — all to Buenos Aires. We add new routes based on community demand.',
      },
      {
        question: 'What payment methods do you accept?',
        answer:
          'Visa, Mastercard, and Amex cards. Stripe for international card payments from any country. SEPA transfers in Europe. Mercado Pago in South America. Funds are released within 1–2 business days after delivery is confirmed.',
      },
    ],
  },
  globe: {
    cities: ['Berlin ★', 'Madrid', 'Rome', 'Paris', 'Lisbon', 'Buenos Aires'],
  },
  contact: {
    id: 'contacto',
    title: 'Have a question or want to join?',
    subtitle:
      'We are in launch phase and want to hear about your case. Complete the form and a team member will contact you within the next 24 hours.',
    emailLabel: 'You can also email us at',
  },
  footer: {
    copyright: '© {year} Bringy. All rights reserved.',
    tagline: 'Real people. Real products. Verified routes.',
    hubBerlin: 'Berlin',
    hubBuenosAires: 'Buenos Aires',
    links: {
      howItWorks: 'How it works',
      whyUs: 'Why Bringy',
      offerings: 'Services',
      faq: 'Frequently asked questions',
      contact: 'Contact',
      impressum: 'Impressum',
      privacy: 'Privacy policy',
    },
    social: {
      instagram: '@bringy',
      linkedin: 'linkedin.com/company/bringy',
      linkedinLabel: 'LinkedIn',
    },
    credits: {
      prefix: 'Made by',
      studio: 'INKSKY independent studio',
    },
  },
  legal: {
    backHome: 'Back to home',
    placeholderNotice: 'Fields marked [COMPLETAR] pending final legal entity incorporation.',
    privacy: {
      title: 'Privacy policy / Datenschutzerklärung',
      body: privacyBody,
    },
    terms: {
      title: 'Terms of use',
      body: 'Bringy acts as an intermediary platform between buyers and travelers. Use implies acceptance of identity verification, transport of legal products only, and dispute resolution according to the platform terms. Final text pending publication.',
    },
    impressum: {
      title: 'Impressum',
      body: impressumBody,
    },
  },
  a11y: {
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    chooseLanguage: 'Choose language',
  },
  forms: {
    backHome: 'Back to home',
    submit: 'Send request',
    successTitle: 'We received your request!',
    successBody:
      'We will contact you within the next 24 hours to coordinate the details. Welcome to Bringy.',
    fields: {
      name: { label: 'Full name', placeholder: 'Your full name' },
      email: { label: 'Email', placeholder: 'you@email.com' },
      role: {
        label: 'I am...',
        placeholder: 'Select an option',
        buyer: 'Buyer',
        traveler: 'Traveler',
      },
      countryRoute: {
        label: 'Route of interest',
        placeholder: 'E.g.: Madrid → Buenos Aires',
        other: 'Other',
      },
      message: {
        label: 'Product or message',
        placeholder: 'Tell us what product you need or what you can carry',
        optional: 'Optional',
      },
    },
    errors: {
      required: 'Please complete this field',
      email: 'Enter a valid email',
      role: 'Select an option',
      submitFailed: 'We could not send the form. Please try again.',
    },
    sending: 'Sending…',
    privacyNote:
      'By submitting you agree that we use this data to contact you about Bringy. See our',
    defaultDescriptions: {
      requestItem: 'Inquiry from contact form',
      becomeTraveler: 'Traveler signup from contact form',
    },
    requestItem: {
      title: 'Find a product',
      subtitle: 'Tell us what you need and we will contact you within 24 hours.',
    },
    becomeTraveler: {
      title: 'Offer as a traveler',
      subtitle: 'Tell us your route and we will contact you within 24 hours.',
    },
  },
}
